import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { name: 'Січень', value: 53 },
  { name: 'Лютий', value: 120 },
  { name: 'Березень', value: 188 },
  { name: 'Квітень', value: 85 },
  { name: 'Травень', value: 129 },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/debtDynamics.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
